import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes/Routes';
import { StoreContextProvider } from 'store';
import { closeSnackbar, SnackbarKey, SnackbarProvider } from 'notistack';
import { CloseOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import ThemeConfig from './ThemeConfig';
import UserDataWrapper from './UserDataWrapper';
import QueryClient from './QueryClient';
import Localization from './Localization';
import Analytics from './Analytics';

const B = (snackbarId: SnackbarKey) => (
  <IconButton onClick={() => closeSnackbar(snackbarId)}>
    <CloseOutlined />
  </IconButton>
);

const App = () => (
  <BrowserRouter>
    <StoreContextProvider>
      <ThemeConfig>
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={5000}
          action={B}
        >
          <Analytics>
            <Localization>
              <QueryClient>
                <UserDataWrapper>
                  <Routes />
                </UserDataWrapper>
              </QueryClient>
            </Localization>
          </Analytics>
        </SnackbarProvider>
      </ThemeConfig>
    </StoreContextProvider>
  </BrowserRouter>
);

export default App;
